import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { EXPERIMENTS } from './experiments';
import { i18n } from './i18n';
import type { ExperimentKey, TrigContext } from './types';

// The old file's dropdown order was the object's own insertion order
// (right-triangle first — a plausibly deliberate pedagogical progression),
// while its default landing experiment (bare URL, no ?exp=/?shot=) was the
// literal 'unit-circle', not order[0]. `defaultExperiment` lets both survive
// unchanged: `order` keeps the original sequence, `defaultExperiment` pins
// the boot-time selection independently of it.
const ORDER = Object.keys(EXPERIMENTS) as ExperimentKey[];

bootstrapDemoShell({
  slug: 'trigonometry',
  i18n,
  experiments: EXPERIMENTS,
  order: ORDER,
  defaultExperiment: 'unit-circle',
  eyebrowKey: 'app.eyebrow',
  selectorAriaLabelKey: 'panel.scene',
  helpLineKeys: ['hint.line1', 'hint.line2', 'hint.line3'],
  shotToExperiment: (id) => (ORDER.includes(id as ExperimentKey) ? (id as ExperimentKey) : null),
  extendContext: (base): TrigContext => base,
});
